import axios from 'axios';
import ContactFormConfiguration from '../models/ContactFormConfiguration';
import ContactFormConfigurationMapper from '../mappers/ContactFormConfigurationMapper';
import ContactFormEntry from '../models/ContactFormEntry';

export default class ContactFormService {
    public async getContactFormConfiguration(formID: string): Promise<ContactFormConfiguration> {
        let api = axios.create({
            baseURL: ''
        })
        const data : any = await api.get('/Contact/ContactFormConfiguration?formID=' + formID);
        
        const configuration : ContactFormConfiguration = new ContactFormConfigurationMapper().map(data.data);
        
        return configuration;
    }

    public async getErrorMessageTranslations() : Promise<any> {
        let api = axios.create({
            baseURL: ''
        })
        const data : any = await api.get("/ResourceString/GetResourceStringsByFilter");

        return data.data;
    }

    public async sendContactForm(values : ContactFormEntry){

        let api = axios.create({
            baseURL: ''
        })

        var bodyFormData = new FormData();
        bodyFormData.append("subject", values.subject.id);
        bodyFormData.append("subjectText", values.subject.text);
        bodyFormData.append("question", values.question);

        for(let i = 0; i < values.files.length; i++){
            const file : File = values.files[i]
            bodyFormData.append("attachment" + i, file);
        }
        bodyFormData.append("firstname", values.firstname);
        bodyFormData.append("lastname", values.lastname);
        bodyFormData.append("email", values.email);
        bodyFormData.append("phone", values.phone);
        bodyFormData.append("postalcode", values.postalcode);
        bodyFormData.append("customerNumber", values.customerNumber);
        bodyFormData.append("dateOfBirth", (values.dateOfBirth ? values.dateOfBirth.getDate() + "/" + (values.dateOfBirth.getMonth() + 1) +"/" + values.dateOfBirth.getFullYear() : ""));
        bodyFormData.append("consent", values.consent.toString());

        const data : any = await api.post('/Contact/SendOnboardingMail', bodyFormData);
    }
}